<ng-container *ngIf="snapProduct !== 'custom'">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'">
        <div class="part1">
            <p [innerHTML]="popUpHeader"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()">
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <app-snapshot-chartsparent style="width: 98%; height: 100%;" *ngIf="item.metric.length>0" [popUp]="true"
                [chart]="visualization" [id]="id" [data]="data" [height]="'100%'" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
            <div class="chart-section-text" *ngIf="item.metric.length<1">
                <div *ngIf="item.metric.length<1 && item.noData==undefined">Widget is not configured.</div>
                <div *ngIf="item.metric.length<1 && item.noData==true">No data available for the selection.</div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && visualization != 'Line Chart' && !multiFunnelPopup">
    <!-- <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'"> -->
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : (showSnapshotARK ? 'popup-snapshot' : 'popup')">
        
        <div class="part1">
            <p [innerHTML]="popUpHeader"></p>

            <!-- for only trendline 2 for customsnapshot -->
            <div class="view-container" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                DocumentClick (DocumentClicked)="closeViewDropdown()">
                <div class="view-Container-text">View</div>
                <div class="viewdropdown">
                    <button class="drop-toggle  flat" (click)="toogleViewDropdown()">
                        <span class="selectText"
                            [title]="viewselected">{{(viewselected==""?'Select':viewselected)}}</span>
                        <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                    </button>
                    <div class="view-drop-down" *ngIf="isviewDropdownOpen"
                        [ngStyle]="{'padding':viewList.length>0?'4px':'0px','border':viewList.length>0?'1px solid #BABABA':'none'}">
                        <div class="item-container" *ngFor="let item of viewList"
                            [ngClass]="{'selected':item.selected}">
                            <input type="radio" class="checkbox-radio" (click)="viewSelected(item)" id="{{item.option}}"
                                [checked]="item.selected">
                            <label for="{{item.option}}" class="checkbox-label"
                                [title]="item.option">{{item.option}}</label><br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="viewdropdown" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                DocumentClick (DocumentClicked)="closeBrandMetricDropdown()">
                <button class="drop-toggle  flat" (click)="toogleBrandMetricDropdown()">
                    <span class="selectText"
                        [title]="metricSelected">{{ getSelectedBMDisplay() }}</span>
                    <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                            src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                </button>
                <div class="view-drop-down" *ngIf="toogleBrandMetricDropdownOpen"
                    [ngStyle]="{'padding':BMList.length>0?'4px':'0px','border':BMList.length>0?'1px solid #BABABA':'none'}">
                    <input type="text"
                        class="bm-search-box"
                        *ngIf="BMList.length > 6"
                        placeholder="Search..."
                        [value]="searchText"
                        (input)="onSearchInput($event)"
                        (click)="$event.stopPropagation()">
                    <div class="item-container" *ngFor="let item of getFilteredBMList();let i=index"
                        [ngClass]="{'selected':item.selected}">
                        <input type="radio" class="checkbox-radio" id="{{item.option}}"
                            (click)="brandMetricSelected(item, BMList.indexOf(item))" [checked]="item.selected">
                        <label for="{{item.option}}" class="checkbox-label"
                            [title]="item.option">{{ getBMItemLabel(item.option) }}</label><br>
                    </div>
                </div>
            </div>
            <!-- end of "for only trendline 2 for customsnapshot -->

            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container" *ngIf="!showSnapshotARK">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <!-- *ngIf="item.metric.length>0" -->
            <app-snapshot-chartsparent [snapProduct]="'custom'" style="width: 98%; height: 100%;"
                [customData]="customData" [isOutput]="true" [popUp]="true" [height]="'22em'" [id]="id"
                [metricSelected]="metricSelected" [brandSelected]="brandSelected" [Top10Toggle]="Top10Toggle"
                [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
            <!-- show no-data for custom popup when there is no metric data -->
            <div class="chart-section-text" *ngIf="customData?.metric?.length==0 || customData?.metric[0]?.metric_value?.length<1 || customData?.noData==true">
                <div *ngIf="customData?.metric?.length==0 || customData?.metric[0]?.metric_value?.length<1 || customData?.noData==true">No data available for the selection.</div>
            </div>
            <div *ngIf="charttype === 'Bubble Chart'" class="note-bottom">
                <!-- Content for Bubble Chart -->
                Note: Bubble Radius:{{zAxisMetric}}
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && multiFunnelPopup">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'multifunnelpopup'">
        <div class="part1">
            <p [innerHTML]="popUpHeader"></p>
            <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                <div class="DataLabel-Container-text">Data Label</div>
                <div class="DataLabel-Container">
                    <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                    <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                        class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                </div>
            </div>
            <div class="Top10-All-Container" *ngIf="Top10Container==true">
                <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                    Top 10
                </div>
                <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                    All
                </div>
            </div>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <!-- FUNNEL chart: keep existing layout unchanged -->
        <ng-container *ngIf="customData.widgetchart_name !== 'Propeller Chart'">
            <div [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'multifunnelpart2'">
                <div class="grid-container">
                    <div class="grid-item" *ngFor="let cell of gridData; let i=index">
                        <h3>{{cell.header}}</h3>
                        <hr>
                        <app-funnelchart1-custom *ngIf="customData.widgetchart_name=='FUNNEL CHART'"
                            [selectedBrand]="cell.header" [isOutput]="true" [multiFunnelPopup]="multiFunnelPopup"
                            [popUp]="false" [customData]="cell.data" [id]="i+90" [height]="'13em'"
                            [gridTempleteColumns]="''" [showXaxisLabels]="i%3==0?true:false"></app-funnelchart1-custom>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- PROPELLER chart: charts on top, shared legend at bottom -->
        <ng-container *ngIf="customData.widgetchart_name === 'Propeller Chart'">
            <div class="propeller-multibrand-layout">
                <div class="propeller-charts-area">
                    <div class="propeller-brand-grid">
                        <div class="propeller-grid-item" *ngFor="let cell of gridData; let i=index">
                            <div class="propeller-brand-title">{{cell.header}}</div>
                            <app-piechart12-custom
                                [selectedBrand]="cell.header" [isOutput]="true" [multiPropellerPopup]="true"
                                [popUp]="false" [customData]="cell.data" [id]="i+90" [height]="'9em'">
                            </app-piechart12-custom>
                        </div>
                    </div>
                </div>
                <div class="propeller-legend-area" id="shared-legend-propeller-container"></div>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="snapProduct == 'custom' && visualization == 'Line Chart'">
    <div [ngClass]="visualization === 'Line Chart' ? 'popup-trend' : 'popup'">
        <div class="part1">
            <p [innerHTML]="popUpHeader"></p>
            <div style="display:flex;align-items:center" class="Icons-Container">
                <!-- <img src="../../../../assets/images/snap_output_icons/info.svg" alt="" style="display:none">
                <img src="../../../../assets/images/snap_output_icons/Icon_collapse.svg" alt=""
                    (click)="collapseExandPopup()"> -->
                <div class="close-icon" (click)="collapseExandPopup()"></div>
            </div>
        </div>
        <hr>
        <div *ngIf="isTrendView" [ngClass]="visualization === 'Line Chart' ? 'part2-trend' : 'part2'">
            <!-- *ngIf="item.metric.length>0" -->
            <div class="dropdowns-conatiner-trend">
                <!-- for only trendline 2 for customsnapshot -->
                <div class="trend-or-samplesize">
                    <div class="toggle-container" (click)="toggleTrendSample('trendview')"
                        [ngClass]="{'Selected':isTrendView}">Trend View</div>
                    <div class="toggle-container" (click)="toggleTrendSample('samplesize')"
                        [ngClass]="{'Selected':isSampleSize}">Sample Size</div>
                </div>
                <div class="view-container" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeViewDropdown()">
                    <div class="view-Container-text">View</div>
                    <div class="viewdropdown">
                        <button class="drop-toggle  flat" (click)="toogleViewDropdown()">
                            <span class="selectText"
                                [title]="viewselected">{{(viewselected==""?'Select':viewselected)}}</span>
                            <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                    src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                        </button>
                        <div class="view-drop-down" *ngIf="isviewDropdownOpen"
                            [ngStyle]="{'padding':viewList.length>0?'4px':'0px','border':viewList.length>0?'1px solid #BABABA':'none'}">
                            <div class="item-container" *ngFor="let item of viewList"
                                [ngClass]="{'selected':item.selected}">
                                <input type="radio" class="checkbox-radio" (click)="viewSelected(item)"
                                    id="{{item.option}}" [checked]="item.selected">
                                <label for="{{item.option}}" class="checkbox-label"
                                    [title]="item.option">{{item.option}}</label><br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="viewdropdown" *ngIf="visualization == 'Line Chart' && trendLineView && trendLineView==2 "
                    DocumentClick (DocumentClicked)="closeBrandMetricDropdown()">
                    <button class="drop-toggle  flat" (click)="toogleBrandMetricDropdown()">
                        <span class="selectText"
                            [title]="metricSelected">{{ getSelectedBMDisplay() }}</span>
                        <span class="fa fa-angle-down arrowicon"><img class="downarrow"
                                src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg"></span>
                    </button>
                    <div class="view-drop-down" *ngIf="toogleBrandMetricDropdownOpen"
                        [ngStyle]="{'padding':BMList.length>0?'4px':'0px','border':BMList.length>0?'1px solid #BABABA':'none'}">
                        <input type="text"
                            class="bm-search-box"
                            *ngIf="BMList.length > 6"
                            placeholder="Search..."
                            [value]="searchText"
                            (input)="onSearchInput($event)"
                            (click)="$event.stopPropagation()">
                        <div class="item-container" *ngFor="let item of getFilteredBMList();let i=index"
                            [ngClass]="{'selected':item.selected}">
                            <input type="radio" class="checkbox-radio" id="{{item.option}}"
                                (click)="brandMetricSelected(item, BMList.indexOf(item))" [checked]="item.selected">
                            <label for="{{item.option}}" class="checkbox-label"
                                [title]="item.option">{{ getBMItemLabel(item.option) }}</label><br>
                        </div>
                    </div>
                </div>
                <!-- end of "for only trendline 2 for customsnapshot -->

                <div class="DataLabel-Container-Main" *ngIf="visualization == 'Line Chart' ">
                    <div class="DataLabel-Container-text">Data Label</div>
                    <div class="DataLabel-Container">
                        <div [style]="DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                            class="DataLabelButtons" (click)="DataLabelOnClick()">On</div>
                        <div [style]="!DataLabelOn?'background-Color:#000000;color:white':'background-Color:#fff;color:black'"
                            class="DataLabelButtons" (click)="DataLabelOffClick()">Off</div>
                    </div>
                </div>
                <div class="Top10-All-Container" *ngIf="Top10Container==true">
                    <div class="Top10-Block" [ngClass]="{'ToggleActive':Top10Toggle}" (click)="Top10selected()">
                        Top 10
                    </div>
                    <div class="All-Block" [ngClass]="{'ToggleActive':!Top10Toggle}" (click)="Allselected()">
                        All
                    </div>
                </div>
            </div>
            <div class="trend-chart">
                <app-snapshot-chartsparent [snapProduct]="'custom'" style="width: 98%; height: 100%;"
                    [customData]="customData" [isOutput]="true" [popUp]="true" [height]="'22em'"
                    [metricSelected]="metricSelected" [brandSelected]="brandSelected" [Top10Toggle]="Top10Toggle"
                    [DataLabelOn]="DataLabelOn"></app-snapshot-chartsparent>
                <!-- show no-data for custom line-chart popup when there is no metric data -->
                <div class="chart-section-text" *ngIf="customData?.metric?.length==0 || customData?.metric[0]?.metric_value?.length<1 || customData?.noData==true">
                    <div>No data available for the selection.</div>
                </div>
                <div *ngIf="charttype === 'Bubble Chart'" class="note-bottom">
                    <!-- Content for Bubble Chart -->
                    Note: Bubble Radius:{{zAxisMetric}}
                </div>
            </div>
        </div>
        <div *ngIf="isSampleSize" [ngClass]="visualization === 'Line Chart' ? 'part2-trend-samplesize' : 'part2'">
            <app-shared-popup-snapshot *ngIf="isSampleSize" [showSampleSizePopup]="isSampleSize"
            [showInputPopUp]="false" [showErrorPopUp]="false" [popUpParameter]="'SampleSize'"
            [OutputdataObject]="OutputdataObject" [snapshotdata]="this.sampleSizeOutputData" [isTranspose]="false"
            [isTotalBase]="true" [isAnswerBase]="false" [isSampleSize]="isSampleSize"
            [TrendToggleContainer]="TrendToggleContainer" [TrendToggleOn]="TrendToggleOn"
          [SnapShotType]="this._configService.selectedSnapshotType"
            [weightSelectedValue]="weightSelectedValue"
            [trendSamplesizeview]="true"
            (toggle)="toggleTrendSample($event)"
            [isTrendView]="isTrendView"
            ></app-shared-popup-snapshot>
        </div>
    </div>
</ng-container>